import { render, staticRenderFns } from "./FormFieldsRadioGroup.vue?vue&type=template&id=88948d74&scoped=true&"
import script from "./FormFieldsRadioGroup.vue?vue&type=script&lang=js&"
export * from "./FormFieldsRadioGroup.vue?vue&type=script&lang=js&"
import style0 from "./FormFieldsRadioGroup.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./FormFieldsRadioGroup.vue?vue&type=style&index=1&id=88948d74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88948d74",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VRadioGroup})
